/* eslint-disable max-len */
/* eslint-disable no-undef */
import React from "react";
import DashboardService from '../services/DashboardService';
import { showLoading } from 'react-global-loading';

export const userData = localStorage.getItem('persist:root') ?
  JSON.parse(JSON.parse(localStorage.getItem('persist:root')).userData) : '';

class OpportunitiesForStudents extends React.Component {
  constructor(props) {
    super(props);
    showLoading(false);
    this.state = {
      data: ''
    };
  }

  componentDidMount = () => {
    this.getData();
  };

  getData = () => {
    DashboardService.getOpportunitiesForStudents()
      .then((result) => {
        if (!result) {
          return;
        }
        this.setState({ data: result.data });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  render() {
    const { data } = this.state;
    return (
      <div className="container" >
        <h2 className="abthdn">{data?.title?.rendered}</h2>
        <div dangerouslySetInnerHTML={{ __html: data?.excerpt?.rendered }} />
      </div>
    );
  }
}
export default OpportunitiesForStudents;